import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { TRANSLATIONS } from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const ANIM_DURATION_MS = 1400;

const formatNumber = (n, locale) =>
  new Intl.NumberFormat(locale === "fr" ? "fr-FR" : "en-US").format(n);

export const GlobalCounter = ({ lang }) => {
  const t = TRANSLATIONS[lang];
  const [target, setTarget] = useState(null);
  const [displayed, setDisplayed] = useState(0);
  const startTsRef = useRef(0);
  const rafRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/stats/global`)
      .then(({ data }) => {
        if (!cancelled) setTarget(data.total_transformations || 0);
      })
      .catch(() => {
        if (!cancelled) setTarget(0);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (target == null) return;
    startTsRef.current = performance.now();
    const tick = (now) => {
      const elapsed = now - startTsRef.current;
      const progress = Math.min(1, elapsed / ANIM_DURATION_MS);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplayed(Math.round(target * eased));
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [target]);

  if (target == null || target <= 0) return null;

  return (
    <div
      data-testid="global-counter"
      className="mt-10 inline-flex items-baseline gap-4 border-l-4 border-black pl-5 py-1"
    >
      <span
        className="font-display font-semibold text-4xl sm:text-5xl tabular-nums leading-none"
        data-testid="global-counter-number"
      >
        {formatNumber(displayed, lang)}
      </span>
      <span className="flex flex-col leading-tight">
        <span className="font-mono text-[11px] uppercase tracking-[0.14em] text-black">
          {t.counterHeadline}
        </span>
        <span className="text-[11px] italic text-[#4A4A4A] mt-0.5 font-normal">
          {t.counterSub}
        </span>
      </span>
    </div>
  );
};
